import { Link } from 'react-router-dom';
import { ROUTES } from '@/app/config/constants';
import './authNotice.css';

/**
 * What the four unbuilt auth routes render.
 *
 * They used to render a bare `<div className="p-4">Register Page</div>`, which
 * reads to whoever followed the link as a page that failed to load: no heading,
 * no explanation, no way onward. Nothing about it says the feature is not built
 * yet rather than broken.
 *
 * So each one now says what it is, why there is nothing here, and offers the
 * route back. Whether password recovery and registration should exist at all is
 * still a product decision -- this does not pre-empt it, it just stops the
 * placeholder from looking like a fault while that decision is outstanding.
 */

interface AuthNoticePageProps {
  title: string;
  /** Why there is nothing here, in the user's terms rather than the backlog's. */
  message: string;
  /** Omitted on the unauthorized page, which is a real state rather than a gap. */
  comingSoon?: boolean;
}

export function AuthNoticePage({ title, message, comingSoon = true }: AuthNoticePageProps) {
  return (
    <main className="auth-notice">
      <div className="auth-notice__card">
        <i
          className={`pi ${comingSoon ? 'pi-clock' : 'pi-lock'} auth-notice__icon`}
          aria-hidden="true"
        />
        <h1 className="auth-notice__title">{title}</h1>
        <p className="auth-notice__message">{message}</p>
        <Link className="auth-notice__link" to={ROUTES.LOGIN}>
          Back to sign in
        </Link>
      </div>
    </main>
  );
}

export default AuthNoticePage;
